import * as React from 'react'
import { FC } from 'react'
import Form from 'antd/es/form'
import { NamePath } from 'antd/es/form/interface'
import Tube from '../../../../../../types/api/tube'
import { EditableContext } from '../editable-row'
import { Input } from 'antd'
import { EndpointQueryParameters } from '../../../../../../types/strapi/strapi'
import { useSaveOrder } from '../../../../helpers/use-save-order'

interface EditableInputProps {
    namePath: NamePath
    record: Tube
    inputRef: any
    queryParams: EndpointQueryParameters
    toggleEdit: () => void
}

const EditableInput: FC<EditableInputProps> = ({
    namePath,
    record,
    inputRef,
    queryParams,
    toggleEdit,
}) => {
    const form = React.useContext(EditableContext)
    const saveOrder = useSaveOrder()

    const initialValue = record.stamps?.[0]?.last_order?.price

    const save = async () => {
        try {
            toggleEdit()
            if (!form) return
            const value = form.getFieldsValue()

            if (record.stamps?.[0]?.last_order) {
                const price = value?.stamps?.[0]?.last_order?.price
                if (price !== undefined) {
                    await saveOrder('price', price, record, queryParams)
                }
            }
        } catch (errInfo) {
            console.log('Save failed:', errInfo)
        }
    }

    return (
        <Form.Item
            initialValue={initialValue}
            style={{
                margin: 0,
            }}
            name={namePath}
        >
            <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
    )
}

export default EditableInput
